var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
__name(_slicedToArray, "_slicedToArray");
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableRest, "_nonIterableRest");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
__name(_iterableToArrayLimit, "_iterableToArrayLimit");
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
__name(_arrayWithHoles, "_arrayWithHoles");
import React, { Children, useRef, useState, useMemo } from "react";
import classNames from "classnames";
import { Button } from "@riseart/common";
import { ArrowLightIcon, CloseIcon } from "@riseart/icons";
import { screenSmall, selectCls, selectOpenedCls, selectEmptyCls, selectInlineCls, selectDropdownListLeftCls, selectDropdownListRightCls, selectNoborderCls, selectInputCls, selectDropdownCls, selectDropdownListCls, selectDropdownListTitleCls, selectDropdownListContentCls, selectDropdownListSummaryCls, selectDropdownListSummaryButtonCls, selectDropdownListItemCls, selectDropdownListItemSelectedCls, selectDropdownListItemDisabledCls } from "./Select.less";
function updatePageScroll() {
  var disableScrolling = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
  if (disableScrolling) {
    document.body.className += " disable-scroll";
  } else {
    document.body.className = document.body.className.replace("disable-scroll", "");
  }
}
__name(updatePageScroll, "updatePageScroll");
function extractSelectedItems(_ref) {
  var _ref$children = _ref.children, children = _ref$children === void 0 ? [] : _ref$children, multiple = _ref.multiple, onError = _ref.onError;
  var selectedItems = [];
  (children || []).forEach(function(_ref2) {
    var childProps = _ref2.props;
    var label = childProps.label, selected = childProps.selected, value = childProps.value;
    if (selected) {
      selectedItems.push({
        label,
        value
      });
    }
  });
  if (!multiple && selectedItems.length > 1 && onError) {
    onError("\n      You specify multiple select options for non-multiple FilterSelect.\n      There should be only one preselected option for non-multiple select FilterSelect.\n      Please add multiple={true} for FilterSelect or pass only one selected child component!\n  ");
  }
  return selectedItems;
}
__name(extractSelectedItems, "extractSelectedItems");
var renderLabelPlaceholder = /* @__PURE__ */ __name(function renderLabelPlaceholder2() {
  var selectedItems = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var _ref3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref3$labels = _ref3.labels, defaultText = _ref3$labels.defaultText, multipleValues = _ref3$labels.multipleValues, noOptions = _ref3$labels.noOptions, children = _ref3.children;
  var totalSelectedItems = selectedItems && selectedItems.length || 0;
  if (!children || !children.length) {
    return noOptions;
  }
  if (totalSelectedItems === 1) {
    return selectedItems && selectedItems[0].label;
  }
  if (totalSelectedItems > 1) {
    return "".concat(totalSelectedItems, " ").concat(multipleValues);
  }
  return defaultText;
}, "renderLabelPlaceholder");
function FilterSelect(_ref4) {
  var className = _ref4.className, _ref4$children = _ref4.children, children = _ref4$children === void 0 ? null : _ref4$children, _ref4$multiple = _ref4.multiple, multiple = _ref4$multiple === void 0 ? false : _ref4$multiple, _ref4$inline = _ref4.inline, inline = _ref4$inline === void 0 ? false : _ref4$inline, _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "right" : _ref4$align, _ref4$border = _ref4.border, border = _ref4$border === void 0 ? true : _ref4$border, _ref4$labels = _ref4.labels, labels = _ref4$labels === void 0 ? {
    defaultText: "",
    multipleValues: "",
    noOptions: "",
    reset: "",
    clearAll: "",
    selectedCount: "",
    listTitle: ""
  } : _ref4$labels, _ref4$showAllOptions = _ref4.showAllOptions, showAllOptions = _ref4$showAllOptions === void 0 ? false : _ref4$showAllOptions, _ref4$onReset = _ref4.onReset, onReset = _ref4$onReset === void 0 ? function() {
  } : _ref4$onReset, _ref4$onChange = _ref4.onChange, onChange = _ref4$onChange === void 0 ? function() {
  } : _ref4$onChange, _ref4$onSelect = _ref4.onSelect, onSelect = _ref4$onSelect === void 0 ? function() {
  } : _ref4$onSelect, _ref4$onDeselect = _ref4.onDeselect, onDeselect = _ref4$onDeselect === void 0 ? function() {
  } : _ref4$onDeselect, _ref4$onBlur = _ref4.onBlur, onBlur = _ref4$onBlur === void 0 ? function() {
  } : _ref4$onBlur, _ref4$onFocus = _ref4.onFocus, onFocus = _ref4$onFocus === void 0 ? function() {
  } : _ref4$onFocus, _ref4$onError = _ref4.onError, onError = _ref4$onError === void 0 ? null : _ref4$onError, dimension = _ref4.dimension, hideSummary = _ref4.hideSummary;
  var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), isOpened = _useState2[0], setIsOpened = _useState2[1];
  var selectRef = useRef(null);
  var selectedItems = useRef(extractSelectedItems({
    children,
    multiple,
    onError
  }));
  var resetLinkProps = useRef();
  selectedItems.current = useMemo(function() {
    return extractSelectedItems({
      children,
      multiple,
      onError
    });
  }, [children, multiple, onError]);
  var selectedOptionsCount = selectedItems.current.length;
  var inputLabel = renderLabelPlaceholder(selectedItems.current, {
    labels,
    children
  });
  var _handleClickOutside = /* @__PURE__ */ __name(function handleClickOutside(event) {
    var clickedClassName = event && event.target && event.target.className;
    var isDropdownWrapperClicked = typeof clickedClassName === "string" && clickedClassName.split(" ").indexOf(selectDropdownCls) !== -1;
    if (isDropdownWrapperClicked || selectRef && selectRef.current && !selectRef.current.contains(event.target)) {
      updatePageScroll();
      setIsOpened(false);
      onBlur();
      document.removeEventListener("mousedown", _handleClickOutside);
    }
  }, "handleClickOutside");
  var closeDropdown = /* @__PURE__ */ __name(function closeDropdown2() {
    updatePageScroll();
    setIsOpened(false);
    onBlur();
    document.removeEventListener("mousedown", _handleClickOutside);
  }, "closeDropdown");
  var resetSelectedItems = /* @__PURE__ */ __name(function resetSelectedItems2() {
    closeDropdown();
    selectedItems.current = [];
    onReset();
    onChange(dimension, resetLinkProps.current, []);
  }, "resetSelectedItems");
  var handleOptionClick = /* @__PURE__ */ __name(function handleOptionClick2(itemProps) {
    var value = itemProps.value, label = itemProps.label;
    return function() {
      var selectedItemsUpdated = _toConsumableArray(selectedItems.current);
      var itemIsSelected = selectedItemsUpdated.some(function(i) {
        return i.value === value;
      });
      closeDropdown();
      onChange(dimension, itemProps, _toConsumableArray(selectedItems.current));
      if (!itemIsSelected) {
        var newValue = {
          value,
          label
        };
        selectedItems.current = multiple ? [].concat(_toConsumableArray(selectedItemsUpdated), [newValue]) : [newValue];
        onSelect(itemProps);
        return;
      }
      selectedItems.current = selectedItemsUpdated.filter(function(i) {
        return i.value !== value;
      });
      onDeselect(itemProps);
    };
  }, "handleOptionClick");
  var handleMobileCloseList = /* @__PURE__ */ __name(function handleMobileCloseList2(e) {
    e.preventDefault();
    closeDropdown();
  }, "handleMobileCloseList");
  var toggleOpen = /* @__PURE__ */ __name(function toggleOpen2() {
    setIsOpened(!isOpened);
    if (isOpened) {
      onBlur();
      document.removeEventListener("mousedown", _handleClickOutside);
    } else {
      onFocus();
      document.addEventListener("mousedown", _handleClickOutside);
    }
    var isOpenedOnSmallScreen = window.innerWidth < parseInt(screenSmall, 10) && !isOpened;
    updatePageScroll(isOpenedOnSmallScreen);
  }, "toggleOpen");
  var resetOption = /* @__PURE__ */ __name(function resetOption2() {
    return /* @__PURE__ */ React.createElement("li", {
      key: "reset-option",
      className: selectDropdownListItemCls,
      onClick: resetSelectedItems
    }, labels.reset);
  }, "resetOption");
  var renderAllOptions = /* @__PURE__ */ __name(function renderAllOptions2() {
    return Children.map(children, function(child) {
      return /* @__PURE__ */ React.cloneElement(child, {
        className: classNames(selectDropdownListItemCls, _defineProperty(_defineProperty({}, selectDropdownListItemSelectedCls, selectedItems.current.some(function(i) {
          return i.value === child.props.value;
        })), selectDropdownListItemDisabledCls, child.props.disabled)),
        handleClick: handleOptionClick(child.props)
      });
    });
  }, "renderAllOptions");
  var renderOptions = /* @__PURE__ */ __name(function renderOptions2() {
    var DEFAULT_AGGREGATED_LIST = {
      selected: [],
      deselected: []
    };
    var combined = [];
    var filteredNodes = Children.toArray(children).reduce(function(aggr, child) {
      if (!child.props.value) {
        resetLinkProps.current = child.props;
        return aggr;
      }
      var isSelected = selectedItems.current.some(function(i) {
        return i.value === child.props.value;
      });
      aggr[isSelected ? "selected" : "deselected"].push(/* @__PURE__ */ React.cloneElement(child, {
        className: classNames(selectDropdownListItemCls, _defineProperty({}, selectDropdownListItemSelectedCls, isSelected)),
        handleClick: handleOptionClick(child.props)
      }));
      return aggr;
    }, DEFAULT_AGGREGATED_LIST);
    filteredNodes.selected = filteredNodes.selected.sort(function(_ref5) {
      var props = _ref5.props;
      return props.children;
    });
    combined = [].concat(_toConsumableArray(filteredNodes.selected), _toConsumableArray(filteredNodes.deselected));
    return combined;
  }, "renderOptions");
  var renderedOptions = showAllOptions ? renderAllOptions() : renderOptions();
  var hasOptions = renderedOptions.length;
  var dropdownList = hasOptions ? /* @__PURE__ */ React.createElement("div", {
    className: selectDropdownCls
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames(selectDropdownListCls, align === "left" && selectDropdownListLeftCls, align === "right" && selectDropdownListRightCls)
  }, /* @__PURE__ */ React.createElement("div", {
    className: selectDropdownListTitleCls
  }, labels.listTitle, /* @__PURE__ */ React.createElement(Button, {
    icon: /* @__PURE__ */ React.createElement(CloseIcon, null),
    type: "link",
    onClick: handleMobileCloseList
  })), /* @__PURE__ */ React.createElement("ul", {
    className: selectDropdownListContentCls
  }, !hideSummary ? /* @__PURE__ */ React.createElement("li", {
    className: selectDropdownListSummaryCls
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, selectedOptionsCount, " ", labels.selectedCount), selectedOptionsCount ? /* @__PURE__ */ React.createElement("div", null, selectedItems.current.reduce(function(list, item, idx) {
    return "".concat(list).concat(idx ? ", " : "").concat(item.label);
  }, "")) : null), selectedItems.current.length && resetLinkProps.current ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Button, {
    isAnchor: true,
    type: "ghost",
    size: "small",
    width: "auto",
    className: selectDropdownListSummaryButtonCls,
    to: resetLinkProps.current.url,
    onClick: resetSelectedItems
  }, labels.clearAll)) : null) : null, renderedOptions))) : null;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(selectCls, className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, selectOpenedCls, isOpened), selectEmptyCls, !hasOptions), selectInlineCls, inline), selectNoborderCls, !border)),
    ref: selectRef
  }, /* @__PURE__ */ React.createElement("div", {
    className: selectInputCls,
    onClick: hasOptions ? toggleOpen : null
  }, inputLabel, /* @__PURE__ */ React.createElement(ArrowLightIcon, null)), dropdownList);
}
__name(FilterSelect, "FilterSelect");
export {
  FilterSelect
};
